import { Component, Input, OnInit } from '@angular/core';
import { TreeControl } from '@angular/cdk/tree';

@Component({
    selector: 'tree-view-tools[treeControl]',
    templateUrl: './tree-view-tools.component.html',
    styleUrls: ['./tree-view-tools.component.css'],
    host: {
        class: 'p-2'
    },
    standalone: false
})
export class TreeViewToolsComponent implements OnInit {
  @Input() treeControl: TreeControl<any>;

  constructor() {}

  ngOnInit(): void {}
}
